/* oddit-section-press-quote — press logos act as tabs that swap the quote.

   All quotes are stacked in one grid cell (see the CSS), so the section always
   reserves the height of the longest one and never resizes on swap.

   With autoplay enabled (data-autoplay / data-autoplay-speed) the quote
   advances on a timer. Rotation pauses while the pointer or focus is inside
   the section, while the section is off-screen, and while the tab is hidden;
   it never runs for visitors who prefer reduced motion. While rotating, the
   quote region's aria-live is "off" so screen readers aren't spammed; it
   returns to "polite" whenever rotation is paused.

   On mobile the logo strip is an infinite ring: the logo set is cloned before
   and after the originals and the scroll position wraps by one period
   whenever it drifts past the boundary copies, so advancing never rewinds.
   The active logo is scrolled to the horizontal center of the strip. */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileMq = window.matchMedia('(max-width: 749px)'); // CSS swipe-strip breakpoint
  var states = [];

  function initSection(section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-press-quote]'));
    var quotes = Array.prototype.slice.call(section.querySelectorAll('[data-press-quote-index]'));
    var strip = section.querySelector('.oddit-section-press-quote__logos');
    var quoteRegion = section.querySelector('.oddit-section-press-quote__quote');
    if (!tabs.length || !quotes.length) return;

    var state = {
      section: section,
      timer: null,
      activeIndex: 0,
      hovered: false,
      focused: false,
      onScreen: true,
      observer: null,
      period: 0,
      onStripScroll: null,
      autoplay: section.getAttribute('data-autoplay') === 'true' && tabs.length > 1,
      delay: (parseFloat(section.getAttribute('data-autoplay-speed')) || 5) * 1000
    };

    function activate(index) {
      state.activeIndex = index;
      var key = String(index);
      // Clones carry the same data-press-quote, so query the strip fresh —
      // active styling then applies to every copy of the logo at once.
      var allTabs = section.querySelectorAll('[data-press-quote]');
      Array.prototype.forEach.call(allTabs, function (t) {
        var on = t.getAttribute('data-press-quote') === key;
        t.classList.toggle('is-active', on);
        if (!t.hasAttribute('data-press-quote-clone')) {
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        }
      });
      quotes.forEach(function (q) {
        q.classList.toggle('is-active', q.getAttribute('data-press-quote-index') === key);
      });
    }

    /* ---------- mobile infinite ring ---------- */

    function loopActive() {
      return state.period > 0;
    }

    function buildLoop() {
      if (loopActive() || !strip || tabs.length < 2) return;
      if (strip.scrollWidth <= strip.clientWidth) return; // nothing to loop

      // Logo sizes come from :nth-child rules, which cloning would reshuffle.
      // Freeze each original's size inline first so every copy keeps it.
      tabs.forEach(function (tab) {
        var cs = getComputedStyle(tab);
        tab.style.width = cs.width;
        tab.style.height = cs.height;
      });

      var makeSet = function () {
        var frag = document.createDocumentFragment();
        tabs.forEach(function (tab) {
          var clone = tab.cloneNode(true);
          clone.setAttribute('data-press-quote-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('tabindex', '-1');
          clone.removeAttribute('role');
          clone.removeAttribute('aria-selected');
          bindTab(clone);
          frag.appendChild(clone);
        });
        return frag;
      };

      var prevScroll = strip.scrollLeft;
      strip.classList.add('is-looping'); // drops scroll-snap; wrapping owns position
      strip.insertBefore(makeSet(), tabs[0]);
      strip.appendChild(makeSet());

      state.period = tabs[0].offsetLeft - strip.querySelector('[data-press-quote-clone]').offsetLeft;
      if (!(state.period > 0)) { destroyLoop(); return; }

      strip.scrollLeft = prevScroll + state.period;

      state.onStripScroll = function () {
        var x = strip.scrollLeft;
        if (x < state.period * 0.5) strip.scrollLeft = x + state.period;
        else if (x > state.period * 1.5) strip.scrollLeft = x - state.period;
      };
      strip.addEventListener('scroll', state.onStripScroll, { passive: true });

      centerTabInStrip(state.activeIndex, 'auto');
    }

    function destroyLoop() {
      if (!strip) return;
      if (state.onStripScroll) {
        strip.removeEventListener('scroll', state.onStripScroll);
        state.onStripScroll = null;
      }
      Array.prototype.slice.call(strip.querySelectorAll('[data-press-quote-clone]')).forEach(function (el) {
        el.remove();
      });
      tabs.forEach(function (tab) {
        tab.style.width = '';
        tab.style.height = '';
      });
      strip.classList.remove('is-looping');
      state.period = 0;
    }

    // Scroll the strip (never the page) so the copy of this logo nearest the
    // current view lands centered — with the ring, that means an advance from
    // the last logo to the first keeps moving forward instead of rewinding.
    function centerTabInStrip(index, behavior) {
      if (!strip || strip.scrollWidth <= strip.clientWidth) return;
      var copies = strip.querySelectorAll('[data-press-quote="' + index + '"]');
      if (!copies.length) return;
      var viewCenter = strip.scrollLeft + strip.clientWidth / 2;
      var best = copies[0];
      var bestDist = Infinity;
      Array.prototype.forEach.call(copies, function (copy) {
        var center = copy.offsetLeft + copy.offsetWidth / 2;
        var dist = Math.abs(center - viewCenter);
        if (dist < bestDist) { bestDist = dist; best = copy; }
      });
      strip.scrollTo({
        left: best.offsetLeft - (strip.clientWidth - best.offsetWidth) / 2,
        behavior: behavior || 'smooth'
      });
    }

    /* ---------- autoplay ---------- */

    function running() {
      return (
        state.autoplay &&
        !reducedMotion.matches &&
        !state.hovered &&
        !state.focused &&
        state.onScreen &&
        !document.hidden
      );
    }

    function sync() {
      if (running()) {
        if (!state.timer) {
          state.timer = setInterval(function () {
            var next = (state.activeIndex + 1) % tabs.length;
            activate(next);
            centerTabInStrip(next);
          }, state.delay);
        }
        if (quoteRegion) quoteRegion.setAttribute('aria-live', 'off');
      } else {
        if (state.timer) {
          clearInterval(state.timer);
          state.timer = null;
        }
        if (quoteRegion) quoteRegion.setAttribute('aria-live', 'polite');
      }
    }

    // Restart the countdown so a manual pick isn't advanced away instantly.
    function restart() {
      if (state.timer) {
        clearInterval(state.timer);
        state.timer = null;
      }
      sync();
    }

    function bindTab(tab) {
      tab.addEventListener('click', function () {
        var index = parseInt(tab.getAttribute('data-press-quote'), 10) || 0;
        activate(index);
        centerTabInStrip(index);
        restart();
      });
    }

    tabs.forEach(bindTab);

    if (strip && tabs.length > 1) {
      if (mobileMq.matches) buildLoop();
      var onMqChange = function (e) {
        if (e.matches) buildLoop();
        else destroyLoop();
      };
      if (mobileMq.addEventListener) mobileMq.addEventListener('change', onMqChange);
      state.onMqChange = onMqChange;
    }

    if (state.autoplay) {
      section.addEventListener('mouseenter', function () { state.hovered = true; sync(); });
      section.addEventListener('mouseleave', function () { state.hovered = false; sync(); });
      section.addEventListener('focusin', function () { state.focused = true; sync(); });
      section.addEventListener('focusout', function () { state.focused = false; sync(); });
      document.addEventListener('visibilitychange', sync);
      if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', sync);

      if ('IntersectionObserver' in window) {
        state.observer = new IntersectionObserver(function (entries) {
          state.onScreen = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.25 });
        state.observer.observe(section);
      }

      sync();
    }

    state.destroy = function () {
      if (state.timer) clearInterval(state.timer);
      state.timer = null;
      if (state.observer) state.observer.disconnect();
      destroyLoop();
      if (state.onMqChange && mobileMq.removeEventListener) {
        mobileMq.removeEventListener('change', state.onMqChange);
      }
      document.removeEventListener('visibilitychange', sync);
      if (reducedMotion.removeEventListener) reducedMotion.removeEventListener('change', sync);
    };

    states.push(state);
  }

  document.querySelectorAll('.oddit-section-press-quote').forEach(initSection);

  // Theme editor: rebuild on section reload so timers don't leak.
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.oddit-section-press-quote');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    states = states.filter(function (state) {
      if (!e.target.contains(state.section)) return true;
      state.destroy();
      return false;
    });
  });
})();
